


























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IOrder} from '@/models/IOrder';
import {DataTableHeader} from 'vuetify';
import {getOrdersOfSheetOrder} from '@/services/SheetOrderService';
import {ILineItem} from '@/models/ILineItem';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

interface IDetailLineItem extends ILineItem {
  order_name: string;
  payment_methods: string[];
  total_price: number;
  ordered_at: string;
  shipping_address: any;
}

@Component({})
export default class DetailLineItemsTable extends Vue {
  @Prop({required: true, type: Number}) sheetOrderId!: number;
  loading: boolean = true;
  detailLineItems: IDetailLineItem[] = [];
  headers: DataTableHeader[] = [
    {text: 'Order ID', sortable: true, value: 'order_name'},
    {text: 'Total price ($)', sortable: false, value: ''},
    {text: 'Ordered At', sortable: false, value: ''},
    {text: 'LineItem Quantity', sortable: false, value: ''},
    {text: 'LineItem Name', sortable: false, value: ''},
    {text: 'LineItem Price ($)', sortable: false, value: ''},
    {text: 'LineItem SKU', sortable: false, value: ''},
    {text: 'Country', sortable: false, value: ''},
    {text: 'Payment Method', sortable: false, value: ''},
  ];

  created() {
    this.loadData();
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    this.loading = true;
    let orders: IOrder[] = [];
    try {
      const cache: any = {};
      orders = await getOrdersOfSheetOrder(this.organizationId, this.shopId, this.sheetOrderId);
      orders.forEach((order) => {
        order.line_items.forEach((lineItem) => {
          this.detailLineItems = [...this.detailLineItems, {
            ...lineItem,
            order_name: order.order_name,
            ordered_at: order.ordered_at,
            payment_methods: order.payment_methods,
            total_price: cache[order.id] ? 0 : order.total_price,
            shipping_address: order.shipping_address,
          }];
          cache[order.id] = 1;
        });
      });
    } finally {
      this.loading = false;
    }
  }
}
